import { getFilterRequest } from '@utils';
import { Text, ITooltip, ButtonText } from '@components/index';
import { useAppSelector } from '@store/redux/store';
import { makeParamsObject } from '@services/queries/equipments/getEquipments/makeParamsObject';
import { Group, Stack } from '@mantine/core';
import { Icon } from '@blueprintjs/core';
import {
  EQUIPMENTS_PICKER_SEND_TYPE,
  EQUIPMENTS_PICKER_STATE_TYPE,
} from '@store/machines/equipmentsPicker';
import { Head, Loading, LoadingDiv } from './Products.styles';
import { GROUP_EDIT_LIMIT } from './Products';
import { SELECT_ALL_LIMIT } from './ExtraMenuOptions';
import { ONLY_GROUP_EDITS_WARN } from './components/ListProducts/ListProducts';

interface MassEditOptionsProps {
  state: EQUIPMENTS_PICKER_STATE_TYPE;
  send: EQUIPMENTS_PICKER_SEND_TYPE;
}
export function MassEditOptions(props: MassEditOptionsProps) {
  const { state, send } = props;
  const { context } = state;

  const onlyGroupEdits = context.data.size > GROUP_EDIT_LIMIT;

  const { filter, inventory } = useAppSelector();

  return (
    <Head>
      <Stack
        spacing={0}
        className="new-icon"
        data-over={onlyGroupEdits}
        sx={{
          '&[data-over="true"] h2': {
            margin: 0,
          },
        }}
      >
        <Text text="pl200">{`${context.data.size} Products Selected to Onboard`}</Text>

        <Group spacing={4} hidden={!onlyGroupEdits}>
          <Icon
            icon="error"
            color="#FF9900"
            size={14}
            data-for="group-edit-warn-icon"
            data-tip={!onlyGroupEdits ? '' : ONLY_GROUP_EDITS_WARN}
          />
          <Text text="pl100" textColor="n700">
            Single edit limit reached.
          </Text>
        </Group>
        <ITooltip id="group-edit-warn-icon" />
      </Stack>

      <ButtonText
        text="b200"
        onClick={() => {
          send({ type: 'STOP-SELECT-ALL' });
          send({ type: 'REMOVE-ALL' });
        }}
      >
        Deselect All
      </ButtonText>
      {state.matches('picking.select-all.loading') ? (
        <LoadingDiv>
          <Loading />
        </LoadingDiv>
      ) : (
        <ButtonText
          text="b200"
          textColor="b401"
          onClick={() => {
            if (inventory.activeTab === 'equipment') {
              const paramsToSelect = makeParamsObject(
                {
                  page: 1,
                  limit: SELECT_ALL_LIMIT,
                  search: filter.lastSearch,
                },
                getFilterRequest(
                  filter.options,
                  inventory.activeTab === 'equipment',
                ),
              );
              const now = Date.now();
              send({
                type: 'SELECT-ALL',
                filter: paramsToSelect,
                time: now,
              });
            }
          }}
        >
          Select All
        </ButtonText>
      )}
    </Head>
  );
}
